// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"ec4b5f37","180":"4214f300","208":"b7dd4913","631":"b2a25ffe","774":"f1215640","787":"b60e9f84","820":"e3da53c2","910":"5da861aa"}[chunkId] + ".chunk.js";
};